import { Component, Input } from '@angular/core';
import { WorkflowVertexSpecification, WorkflowVertexVisualization } from 'component.workflow.core';

@Component({
  selector: 'wf-vertex-library-item',
  template: `

    <div class="item">
      <svg:svg xmlns="http://www.w3.org/2000/svg" version="1.1"
               [attr.width]="width" [attr.height]="height" [attr.viewBox]="viewBox">

        <svg:path [attr.d]="vis.shape.representation.path.join(' ')" stroke-linecap="round"
                  [attr.stroke]="vis.stroke.fill" [attr.stroke-width]="vis.stroke.width"
                  [attr.fill]="vis.shape.fill"/>

        <svg:text [attr.x]="vis.text.primary.at.x" text-anchor="middle" [attr.y]="vis.text.icon.at.y"
                  [attr.font-size]="vis.text.icon.size"
                  [attr.fill]="vis.text.icon.fill">{{ vertex.abbr }}
        </svg:text>

      </svg:svg>

      <div>{{ vertex.name }}</div>
    </div>
  `,
  styles: [ `
    :host {
      display: inline-block;
      text-align: center;
      line-height: 0.75rem;
      flex: 1;
      font-size: 90%;
      cursor: pointer;
    }

    * {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      cursor: pointer;
    }

    svg {
      opacity: 0.65;
      transition: 500ms;
      transition-timing-function: ease-in-out;
      transition-property: opacity;
    }

    .item:hover svg {
      opacity: 1;
    }
  ` ]
})
export class WorkflowVertexLibraryItemComponent {
  @Input() vertex: WorkflowVertexSpecification;

  @Input() width = 45;
  @Input() height = 45;

  get viewBox(): string {
    return [ -this.width / 2, -this.height / 2, this.width, this.height ].join(' ');
  }

  get vis(): WorkflowVertexVisualization {
    return this.vertex.visualization;
  }
}



// WEBPACK FOOTER //
// ./src/library/vertex-library/workflow-vertex-library-item.component.ts